module.exports = __webpack_public_path__ + "img/dropping keystones.7170329a.png";